import axios from '@/libs/axios';

export default {
  getStats() {
    return axios.get('/admin/stats')
  }
}
